import { useSite } from '../context/SiteContext';
import { elifHakanInvitation } from '../data/invitations/elifHakanInvitation';
import './DigitalInvitePreview.css';

const fallback = elifHakanInvitation;

function previewTitle(data) {
  return data?.landing?.title
    ?? [data?.couple?.bride, data?.couple?.groom].filter(Boolean).join(' & ')
    ?? 'Elif & Hakan';
}

function previewInitials(data) {
  return data?.couple?.initials
    ?? [data?.couple?.bride, data?.couple?.groom]
      .filter(Boolean)
      .map((name) => name[0])
      .join('&')
    ?? 'E&H';
}

export default function DigitalInvitePreview() {
  const { featuredDigitalInvitation } = useSite();
  const data = featuredDigitalInvitation ?? fallback;

  const bg = data.landing?.background ?? '';
  const seal = data.envelope?.seal ?? '';
  const invite = data.gallery?.mobile?.[0]?.src
    ?? data.gallery?.left?.[0]?.src
    ?? '';
  const title = previewTitle(data);
  const initials = previewInitials(data);
  const names = [data.couple?.bride, data.couple?.groom].filter(Boolean);

  return (
    <div className="dip-preview" aria-hidden="true">
      <div className="dip-preview__phone">
        <div className="dip-preview__notch" />
        <div className="dip-preview__screen">
          <div className="dip-preview__scene">
            <div
              className="dip-preview__bg"
              style={bg ? { backgroundImage: `url(${bg})` } : undefined}
            />

            <p className="dip-preview__title">{title}</p>

            <div className="dip-preview__envelope">
              <div className="dip-preview__card">
                <div className="dip-preview__card-paper" />
                <div className="dip-preview__card-body">
                  <span className="dip-preview__card-eyebrow">Evleniyoruz</span>
                  <span className="dip-preview__card-initials">{initials}</span>
                  <p className="dip-preview__card-names">
                    {names.length >= 2 ? (
                      <>
                        {names[0]} <span>&amp;</span> {names[1]}
                      </>
                    ) : (
                      title
                    )}
                  </p>
                </div>
              </div>

              <div className="dip-preview__back" />
              <div className="dip-preview__inside">
                <div className="dip-preview__fold dip-preview__fold--left" />
                <div className="dip-preview__fold dip-preview__fold--right" />
              </div>
              <div className="dip-preview__pocket" />
              <div className="dip-preview__front" />

              <div className="dip-preview__flap">
                <div className="dip-preview__flap-inner" />
              </div>

              <div className="dip-preview__seal">
                {seal ? <img src={seal} alt="" draggable={false} /> : null}
                <span>{initials}</span>
              </div>
            </div>

            {invite ? (
              <div
                className="dip-preview__invite"
                style={{ backgroundImage: `url(${invite})` }}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
